<ion-header class="particulier-header">
  <div class="particulier-header__toolbar">
    <div class="particulier-header__toolbar__header">
      <a (click)="closeModal()" class="particulier-header__back-link"></a>
      <h2 class="particulier-header__toolbar__title">
        {{ 'CGU_CLIENT.TITLE' | translate }}
      </h2>
    </div>
  </div>
</ion-header>
<ion-content class="cgu-client-modal-content">
  <div class="legals-modal-logo">
    <app-logo [src]="'../../../assets/icon/logo.png'" [alt]="'App Logo'" [width]="'80px'"
      [height]="'auto'" [showVersion]="false" [enableScale]="true">
    </app-logo>
  </div>
  <div class="cgu-client-modal-body">
    <!-- CGU CLIENT CONTENT -->
    <ng-container *ngIf="isClient">      
      <!-- <h3 class="legals-modal-app-name">{{ 'CGU_CLIENT.APP_NAME' | translate }}</h3> -->
      <p><strong>{{ 'CGU_CLIENT.LAST_UPDATE' | translate }}</strong> 12-12-2025</p>

      <h3>{{ 'CGU_CLIENT.SECTION_1_TITLE' | translate }}</h3>
      <p class="legals-modal-section-1-p2">{{ 'CGU_CLIENT.SECTION_1_P1' | translate }}</p>
      <ul class="legals-modal-section-1-p2-list">
        <li>{{ 'CGU_CLIENT.SECTION_1_LI1' | translate }}</li>
        <li>{{ 'CGU_CLIENT.SECTION_1_LI2' | translate }}</li>
        <li>{{ 'CGU_CLIENT.SECTION_1_LI3' | translate }}</li>
        <li>{{ 'CGU_CLIENT.SECTION_1_LI4' | translate }}</li>
      </ul>

      <h3>{{ 'CGU_CLIENT.SECTION_2_TITLE' | translate }}</h3>
      <p class="legals-modal-section-1-p2">{{ 'CGU_CLIENT.SECTION_2_P1' | translate }}</p>
      <p class="legals-modal-section-1-p2">{{ 'CGU_CLIENT.SECTION_2_P2' | translate }}</p>

      <h3>{{ 'CGU_CLIENT.SECTION_3_TITLE' | translate }}</h3>
      <p class="legals-modal-section-1-p2">{{ 'CGU_CLIENT.SECTION_3_P1' | translate }}</p>
      <ul class="legals-modal-section-1-p2-list">
        <li>{{ 'CGU_CLIENT.SECTION_3_LI1' | translate }}</li>
        <li>{{ 'CGU_CLIENT.SECTION_3_LI2' | translate }}</li>
        <li>{{ 'CGU_CLIENT.SECTION_3_LI3' | translate }}</li>
      </ul>
      <p class="legals-modal-section-1-p2">{{ 'CGU_CLIENT.SECTION_3_P2' | translate }}</p>
      <ul class="legals-modal-section-1-p2-list">
        <li>{{ 'CGU_CLIENT.SECTION_3_LI4' | translate }}</li>
        <li>{{ 'CGU_CLIENT.SECTION_3_LI5' | translate }}</li>
        <li>{{ 'CGU_CLIENT.SECTION_3_LI6' | translate }}</li>
      </ul>

      <h3>{{ 'CGU_CLIENT.SECTION_4_TITLE' | translate }}</h3>
      <p class="legals-modal-section-1-p2">{{ 'CGU_CLIENT.SECTION_4_P1' | translate }}</p>
      <ul class="legals-modal-section-1-p2-list">
        <li>{{ 'CGU_CLIENT.SECTION_4_LI1' | translate }}</li>
        <li>{{ 'CGU_CLIENT.SECTION_4_LI2' | translate }}</li>
        <li>{{ 'CGU_CLIENT.SECTION_4_LI3' | translate }}</li>
        <li>{{ 'CGU_CLIENT.SECTION_4_LI4' | translate }}</li>
      </ul>
      <h4 class="legals-modal-section-3-subtitle">{{ 'CGU_CLIENT.SECTION_4_SUBTITLE' | translate }}</h4>
      <p class="legals-modal-section-1-p2">{{ 'CGU_CLIENT.SECTION_4_P2' | translate }}</p>
      <p class="legals-modal-section-1-p2">{{ 'CGU_CLIENT.SECTION_4_P3' | translate }}</p>

      <h3>{{ 'CGU_CLIENT.SECTION_5_TITLE' | translate }}</h3>
      <p class="legals-modal-section-1-p2">{{ 'CGU_CLIENT.SECTION_5_P1' | translate }}</p>
      <ul class="legals-modal-section-1-p2-list">
        <li>{{ 'CGU_CLIENT.SECTION_5_LI1' | translate }}</li>
        <li>{{ 'CGU_CLIENT.SECTION_5_LI2' | translate }}</li>
        <li>{{ 'CGU_CLIENT.SECTION_5_LI3' | translate }}</li>
      </ul>
      <p class="legals-modal-section-1-p2">{{ 'CGU_CLIENT.SECTION_5_P2' | translate }}</p>
      <p class="legals-modal-section-1-p2">{{ 'CGU_CLIENT.SECTION_5_P3' | translate }}</p>

      <h3>{{ 'CGU_CLIENT.SECTION_6_TITLE' | translate }}</h3>
      <p class="legals-modal-section-1-p2">{{ 'CGU_CLIENT.SECTION_6_P1' | translate }}</p>
      <ul class="legals-modal-section-1-p2-list">
        <li>{{ 'CGU_CLIENT.SECTION_6_LI1' | translate }}</li>
        <li>{{ 'CGU_CLIENT.SECTION_6_LI2' | translate }}</li>
        <li>{{ 'CGU_CLIENT.SECTION_6_LI3' | translate }}</li>
      </ul>
      <p class="legals-modal-section-1-p2">{{ 'CGU_CLIENT.SECTION_6_P2' | translate }}</p>
      <ul class="legals-modal-section-1-p2-list">
        <li>{{ 'CGU_CLIENT.SECTION_6_LI4' | translate }}</li>
        <li>{{ 'CGU_CLIENT.SECTION_6_LI5' | translate }}</li>
        <li>{{ 'CGU_CLIENT.SECTION_6_LI6' | translate }}</li>
      </ul>

      <h3>{{ 'CGU_CLIENT.SECTION_7_TITLE' | translate }}</h3>
      <p class="legals-modal-section-1-p2">{{ 'CGU_CLIENT.SECTION_7_P1' | translate }}</p>
      <ul class="legals-modal-section-1-p2-list">
        <li>{{ 'CGU_CLIENT.SECTION_7_LI1' | translate }}</li>
        <li>{{ 'CGU_CLIENT.SECTION_7_LI2' | translate }}</li>
        <li>{{ 'CGU_CLIENT.SECTION_7_LI3' | translate }}</li>
      </ul>
      <p class="legals-modal-section-1-p2">{{ 'CGU_CLIENT.SECTION_7_P2' | translate }}</p>

      <h3>{{ 'CGU_CLIENT.SECTION_8_TITLE' | translate }}</h3>
      <p class="legals-modal-section-1-p2">{{ 'CGU_CLIENT.SECTION_8_P1' | translate }}</p>
      <ul class="legals-modal-section-1-p2-list">
        <li>{{ 'CGU_CLIENT.SECTION_8_LI1' | translate }}</li>
        <li>{{ 'CGU_CLIENT.SECTION_8_LI2' | translate }}</li>
        <li>{{ 'CGU_CLIENT.SECTION_8_LI3' | translate }}</li>
        <li>{{ 'CGU_CLIENT.SECTION_8_LI4' | translate }}</li>
      </ul>
      <p class="legals-modal-section-1-p2">{{ 'CGU_CLIENT.SECTION_8_P2' | translate }}</p>
      <p class="legals-modal-section-1-p2">{{ 'CGU_CLIENT.SECTION_8_P3' | translate }}</p>

      <h3>{{ 'CGU_CLIENT.SECTION_9_TITLE' | translate }}</h3>
      <p class="legals-modal-section-1-p2">{{ 'CGU_CLIENT.SECTION_9_P1' | translate }}</p>
      <p class="legals-modal-section-1-p2">{{ 'CGU_CLIENT.SECTION_9_P2' | translate }}</p>
      <ul class="legals-modal-section-1-p2-list">
        <li>{{ 'CGU_CLIENT.SECTION_9_LI1' | translate }}</li>
        <li>{{ 'CGU_CLIENT.SECTION_9_LI2' | translate }}</li>
        <li>{{ 'CGU_CLIENT.SECTION_9_LI3' | translate }}</li>
      </ul>
      <p class="legals-modal-section-1-p2">{{ 'CGU_CLIENT.SECTION_9_P3' | translate }}</p>

      <h3>{{ 'CGU_CLIENT.SECTION_10_TITLE' | translate }}</h3>
      <p class="legals-modal-section-1-p2">{{ 'CGU_CLIENT.SECTION_10_P1' | translate }}</p>
      <ul class="legals-modal-section-1-p2-list">
        <li>{{ 'CGU_CLIENT.SECTION_10_LI1' | translate }}</li>
        <li>{{ 'CGU_CLIENT.SECTION_10_LI2' | translate }}</li>
        <li>{{ 'CGU_CLIENT.SECTION_10_LI3' | translate }}</li>
        <li>{{ 'CGU_CLIENT.SECTION_10_LI4' | translate }}</li>
      </ul>

      <h3>{{ 'CGU_CLIENT.SECTION_11_TITLE' | translate }}</h3>
      <p class="legals-modal-section-1-p2">{{ 'CGU_CLIENT.SECTION_11_P1' | translate }}</p>
      <ul class="legals-modal-section-1-p2-list">
        <li>{{ 'CGU_CLIENT.SECTION_11_LI1' | translate }}</li>
        <li>{{ 'CGU_CLIENT.SECTION_11_LI2' | translate }}</li>
        <li>{{ 'CGU_CLIENT.SECTION_11_LI3' | translate }}</li>
        <li>{{ 'CGU_CLIENT.SECTION_11_LI4' | translate }}</li>
      </ul>
      <p class="legals-modal-section-1-p2">{{ 'CGU_CLIENT.SECTION_11_P2' | translate }}</p>

      <h3>{{ 'CGU_CLIENT.SECTION_12_TITLE' | translate }}</h3>
      <p class="legals-modal-section-1-p2">{{ 'CGU_CLIENT.SECTION_12_P1' | translate }}</p>
      <p class="legals-modal-section-1-p2">{{ 'CGU_CLIENT.SECTION_12_P2' | translate }}</p>

      <h3>{{ 'CGU_CLIENT.SECTION_13_TITLE' | translate }}</h3>
      <p class="legals-modal-section-1-p2">{{ 'CGU_CLIENT.SECTION_13_P1' | translate }}</p>
      <ul class="legals-modal-section-1-p2-list">
        <li>{{ 'CGU_CLIENT.SECTION_13_LI1' | translate }}</li>
        <li>{{ 'CGU_CLIENT.SECTION_13_LI2' | translate }}</li>
        <li>{{ 'CGU_CLIENT.SECTION_13_LI3' | translate }}</li>
        <li>{{ 'CGU_CLIENT.SECTION_13_LI4' | translate }}</li>
        <li>{{ 'CGU_CLIENT.SECTION_13_LI5' | translate }}</li>
      </ul>

      <h3>{{ 'CGU_CLIENT.SECTION_14_TITLE' | translate }}</h3>
      <p class="legals-modal-section-1-p2">{{ 'CGU_CLIENT.SECTION_14_P1' | translate }}</p>
      <ul class="legals-modal-section-1-p2-list">
        <li>{{ 'CGU_CLIENT.SECTION_14_LI1' | translate }}</li>
        <li>{{ 'CGU_CLIENT.SECTION_14_LI2' | translate }}</li>
        <li>{{ 'CGU_CLIENT.SECTION_14_LI3' | translate }}</li>
      </ul>
    </ng-container>

    <!-- CGU PROFESSIONAL CONTENT -->
    <ng-container *ngIf="isProfessional">
      <h1 class="modal-title">{{ 'CGU_PROFESSIONAL.TITLE' | translate }}</h1>
      
      <h3 class="legals-modal-app-name">{{ 'CGU_PROFESSIONAL.APP_NAME' | translate }}</h3>
      <p><strong>{{ 'CGU_PROFESSIONAL.LAST_UPDATE' | translate }}</strong> ____________</p>

      <h3>{{ 'CGU_PROFESSIONAL.SECTION_1_TITLE' | translate }}</h3>
      <p>{{ 'CGU_PROFESSIONAL.SECTION_1_P1' | translate }}</p>

      <h3>{{ 'CGU_PROFESSIONAL.SECTION_2_TITLE' | translate }}</h3>
      <p class="legals-modal-section-1-p2">{{ 'CGU_PROFESSIONAL.SECTION_2_P1' | translate }}</p>
      <ul class="legals-modal-section-1-p2-list">
        <li>{{ 'CGU_PROFESSIONAL.SECTION_2_LI1' | translate }}</li>
        <li>{{ 'CGU_PROFESSIONAL.SECTION_2_LI2' | translate }}</li>
        <li>{{ 'CGU_PROFESSIONAL.SECTION_2_LI3' | translate }}</li>
        <li>{{ 'CGU_PROFESSIONAL.SECTION_2_LI4' | translate }}</li>
        <li>{{ 'CGU_PROFESSIONAL.SECTION_2_LI5' | translate }}</li>
      </ul>
      <p class="legals-modal-section-1-p2">{{ 'CGU_PROFESSIONAL.SECTION_2_P2' | translate }}</p>

      <h3>{{ 'CGU_PROFESSIONAL.SECTION_3_TITLE' | translate }}</h3>
      <p class="legals-modal-section-1-p2">{{ 'CGU_PROFESSIONAL.SECTION_3_P1' | translate }}</p>
      <ul class="legals-modal-section-1-p2-list">
        <li>{{ 'CGU_PROFESSIONAL.SECTION_3_LI1' | translate }}</li>
        <li>{{ 'CGU_PROFESSIONAL.SECTION_3_LI2' | translate }}</li>
        <li>{{ 'CGU_PROFESSIONAL.SECTION_3_LI3' | translate }}</li>
        <li>{{ 'CGU_PROFESSIONAL.SECTION_3_LI4' | translate }}</li>
        <li>{{ 'CGU_PROFESSIONAL.SECTION_3_LI5' | translate }}</li>
      </ul>
      <p class="legals-modal-section-1-p2">{{ 'CGU_PROFESSIONAL.SECTION_3_P2' | translate }}</p>

      <h3>{{ 'CGU_PROFESSIONAL.SECTION_4_TITLE' | translate }}</h3>
      <p class="legals-modal-section-1-p2">{{ 'CGU_PROFESSIONAL.SECTION_4_P1' | translate }}</p>
      <ul class="legals-modal-section-1-p2-list">
        <li>{{ 'CGU_PROFESSIONAL.SECTION_4_LI1' | translate }}</li>
        <li>{{ 'CGU_PROFESSIONAL.SECTION_4_LI2' | translate }}</li>
        <li>{{ 'CGU_PROFESSIONAL.SECTION_4_LI3' | translate }}</li>
        <li>{{ 'CGU_PROFESSIONAL.SECTION_4_LI4' | translate }}</li>
        <li>{{ 'CGU_PROFESSIONAL.SECTION_4_LI5' | translate }}</li>
        <li>{{ 'CGU_PROFESSIONAL.SECTION_4_LI6' | translate }}</li>
      </ul>
      <p class="legals-modal-section-1-p2">{{ 'CGU_PROFESSIONAL.SECTION_4_P2' | translate }}</p>

      <h3>{{ 'CGU_PROFESSIONAL.SECTION_5_TITLE' | translate }}</h3>
      <p class="legals-modal-section-1-p2">{{ 'CGU_PROFESSIONAL.SECTION_5_P1' | translate }}</p>
      <ul class="legals-modal-section-1-p2-list">
        <li>{{ 'CGU_PROFESSIONAL.SECTION_5_LI1' | translate }}</li>
        <li>{{ 'CGU_PROFESSIONAL.SECTION_5_LI2' | translate }}</li>
        <li>{{ 'CGU_PROFESSIONAL.SECTION_5_LI3' | translate }}</li>
        <li>{{ 'CGU_PROFESSIONAL.SECTION_5_LI4' | translate }}</li>
        <li>{{ 'CGU_PROFESSIONAL.SECTION_5_LI5' | translate }}</li>
        <li>{{ 'CGU_PROFESSIONAL.SECTION_5_LI6' | translate }}</li>
      </ul>
      <p class="legals-modal-section-1-p2">{{ 'CGU_PROFESSIONAL.SECTION_5_P2' | translate }}</p>
      <ul class="legals-modal-section-1-p2-list">
        <li>{{ 'CGU_PROFESSIONAL.SECTION_5_LI7' | translate }}</li>
        <li>{{ 'CGU_PROFESSIONAL.SECTION_5_LI8' | translate }}</li>
      </ul>

      <h3>{{ 'CGU_PROFESSIONAL.SECTION_6_TITLE' | translate }}</h3>
      <p class="legals-modal-section-1-p2">{{ 'CGU_PROFESSIONAL.SECTION_6_P1' | translate }}</p>
      <p class="legals-modal-section-1-p2">{{ 'CGU_PROFESSIONAL.SECTION_6_P2' | translate }}</p>
      <ul class="legals-modal-section-1-p2-list">
        <li>{{ 'CGU_PROFESSIONAL.SECTION_6_LI1' | translate }}</li>
        <li>{{ 'CGU_PROFESSIONAL.SECTION_6_LI2' | translate }}</li>
        <li>{{ 'CGU_PROFESSIONAL.SECTION_6_LI3' | translate }}</li>
      </ul>

      <h3>{{ 'CGU_PROFESSIONAL.SECTION_7_TITLE' | translate }}</h3>
      <p class="legals-modal-section-1-p2">{{ 'CGU_PROFESSIONAL.SECTION_7_P1' | translate }}</p>
      <p class="legals-modal-section-1-p2">{{ 'CGU_PROFESSIONAL.SECTION_7_P2' | translate }}</p>

      <h3>{{ 'CGU_PROFESSIONAL.SECTION_8_TITLE' | translate }}</h3>
      <p class="legals-modal-section-1-p2">{{ 'CGU_PROFESSIONAL.SECTION_8_P1' | translate }}</p>
      <ul class="legals-modal-section-1-p2-list">
        <li>{{ 'CGU_PROFESSIONAL.SECTION_8_LI1' | translate }}</li>
        <li>{{ 'CGU_PROFESSIONAL.SECTION_8_LI2' | translate }}</li>
        <li>{{ 'CGU_PROFESSIONAL.SECTION_8_LI3' | translate }}</li>
      </ul>
      <p class="legals-modal-section-1-p2">{{ 'CGU_PROFESSIONAL.SECTION_8_P2' | translate }}</p>
      <ul class="legals-modal-section-1-p2-list">
        <li>{{ 'CGU_PROFESSIONAL.SECTION_8_LI4' | translate }}</li>
        <li>{{ 'CGU_PROFESSIONAL.SECTION_8_LI5' | translate }}</li>
        <li>{{ 'CGU_PROFESSIONAL.SECTION_8_LI6' | translate }}</li>
      </ul>

      <h3>{{ 'CGU_PROFESSIONAL.SECTION_9_TITLE' | translate }}</h3>
      <p class="legals-modal-section-1-p2">{{ 'CGU_PROFESSIONAL.SECTION_9_P1' | translate }}</p>
      <p class="legals-modal-section-1-p2">{{ 'CGU_PROFESSIONAL.SECTION_9_P2' | translate }}</p>

      <h3>{{ 'CGU_PROFESSIONAL.SECTION_10_TITLE' | translate }}</h3>
      <p class="legals-modal-section-1-p2">{{ 'CGU_PROFESSIONAL.SECTION_10_P1' | translate }}</p>
      <ul class="legals-modal-section-1-p2-list">
        <li>{{ 'CGU_PROFESSIONAL.SECTION_10_LI1' | translate }}</li>
        <li>{{ 'CGU_PROFESSIONAL.SECTION_10_LI2' | translate }}</li>
        <li>{{ 'CGU_PROFESSIONAL.SECTION_10_LI3' | translate }}</li>
        <li>{{ 'CGU_PROFESSIONAL.SECTION_10_LI4' | translate }}</li>
        <li>{{ 'CGU_PROFESSIONAL.SECTION_10_LI5' | translate }}</li>
        <li>{{ 'CGU_PROFESSIONAL.SECTION_10_LI6' | translate }}</li>
      </ul>

      <h3>{{ 'CGU_PROFESSIONAL.SECTION_11_TITLE' | translate }}</h3>
      <p class="legals-modal-section-1-p2">{{ 'CGU_PROFESSIONAL.SECTION_11_P1' | translate }}</p>
      <p class="legals-modal-section-1-p2">{{ 'CGU_PROFESSIONAL.SECTION_11_P2' | translate }}</p>
    </ng-container>

  </div>
</ion-content>
